module.exports = __webpack_public_path__ + "img/Secured-by-apaym-pci-dss.f77f28ca.png";